export default <UiState>{
    darkMode: false,
    navbarVariant: 'navbar-light-1',
    sidebarSkin: 'sidebar-dark-primary',
    menuSidebarCollapsed: false,
    controlSidebarCollapsed: true,
    taskSidebarCollapsed: true,
    taskModalVisible: false,
    selectedTask: null,
    parentTask: null
    // screenSize: calculateWindowSize(window.innerWidth)
};

export interface UiState {
    darkMode: boolean;
    menuSidebarCollapsed: boolean;
    controlSidebarCollapsed: boolean;
    taskSidebarCollapsed: boolean;
    navbarVariant: string;
    sidebarSkin: string;
    screenSize: any;
    taskModalVisible: boolean;
    selectedTask: any | null;
    parentTask: any | null;
}
